module.exports = __webpack_public_path__ + "static/img/裝櫃-黃泓浩.b1e99cd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/裝櫃-黃泓浩.jpeg
// module id = gM1C
// module chunks = 1